// Frontend-only Slack Incoming Webhook notification.
// Fires on successful email unlock. Fire-and-forget — never blocks the UI or surfaces errors to the user.
//
// Setup:
//   1. In Slack, go to https://api.slack.com/apps → Create New App → From scratch
//   2. Add feature: Incoming Webhooks → Activate → Add New Webhook to Workspace → pick channel
//   3. Copy the webhook URL (https://hooks.slack.com/services/T.../B.../xxx)
//   4. Put it in frontend/.env as REACT_APP_SLACK_WEBHOOK_URL and redeploy

const WEBHOOK_URL = process.env.REACT_APP_SLACK_WEBHOOK_URL;

const fmt = (cur, v) =>
  v == null || isNaN(v) ? "—" : `${cur || ""}${Math.round(v).toLocaleString("en-US")}`;

export async function notifyLead({ audit, firstName, email, brandName }) {
  if (!WEBHOOK_URL) return; // silently skip when not configured

  const meta = audit?.meta || {};
  const sc = audit?.scorecard || {};
  const cur = meta.currency || "";
  const displayBrand = brandName || meta.inferredBrand?.value || "—";
  const marketplace = meta.marketplace || "—";
  const score = audit?.score?.value ?? "—";
  const coverage = audit?.coverage?.pct ?? "—";
  const monthly = fmt(cur, sc.monthlyProfitImpact);
  const annual = fmt(cur, (sc.monthlyProfitImpact || 0) * 12);
  const auditUrl = `${window.location.origin}/audit/${audit?.auditId || ""}`;

  const payload = {
    text: `New scorecard lead: ${firstName || "—"} · ${email} · ${monthly}/mo profit impact`,
    blocks: [
      {
        type: "header",
        text: { type: "plain_text", text: "🎯 New Profit Scorecard lead", emoji: true },
      },
      {
        type: "section",
        fields: [
          { type: "mrkdwn", text: `*Name*\n${firstName || "—"}` },
          { type: "mrkdwn", text: `*Work email*\n<mailto:${email}|${email}>` },
          { type: "mrkdwn", text: `*Brand*\n${displayBrand}` },
          { type: "mrkdwn", text: `*Marketplace*\nAmazon ${marketplace}` },
        ],
      },
      {
        type: "section",
        fields: [
          { type: "mrkdwn", text: `*Monthly profit impact*\n${monthly}` },
          { type: "mrkdwn", text: `*Annualised*\n${annual}` },
          { type: "mrkdwn", text: `*Account score*\n${score}/100` },
          { type: "mrkdwn", text: `*Coverage*\n${coverage}%` },
        ],
      },
      {
        type: "actions",
        elements: [
          {
            type: "button",
            text: { type: "plain_text", text: "Open scorecard", emoji: true },
            url: auditUrl,
            style: "primary",
          },
        ],
      },
      {
        type: "context",
        elements: [
          { type: "mrkdwn", text: `_${new Date().toISOString()}_ · audit \`${audit?.auditId || "—"}\`` },
        ],
      },
    ],
  };

  try {
    // Slack Incoming Webhooks accept a raw JSON string body without a preflight
    // when Content-Type is not application/json. Using no explicit header + text body avoids CORS preflight.
    await fetch(WEBHOOK_URL, { method: "POST", body: JSON.stringify(payload) });
  } catch {
    // fire-and-forget — never block the UI
  }
}
